import { useNavigate } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { routeEndpoints } from "@/routes/endpoint";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white shadow-xl rounded-2xl p-10 flex flex-col items-center">
        <ExclamationTriangleIcon className="h-16 w-16 text-yellow-500" />
        <h1 className="mt-6 text-6xl font-bold text-gray-800 animate-pulse">
          404
        </h1>
        <p className="mt-2 text-gray-600 text-center">
          Oops! The page you’re looking for doesn’t exist.
        </p>

        <button
          onClick={() => navigate(routeEndpoints.analyticsDashboard)}
          className="mt-6 rounded-xl cursor-pointer bg-blue-500 hover:bg-blue-600 px-6 py-3 text-white font-semibold shadow-md transition"
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
